// Where the portal lives in the URL.
//
// On a dedicated parent hostname (parents.fleet-lab.com,
// parents-alpha.fleet-lab.com, parent.<anything>) the portal owns the whole
// site: home is "/" and sign-in is "/login". Everywhere else (localhost, the
// admin hostnames) it is tucked under "/portal" so it can share the deployment
// with the admin app. Both forms serve the same bundle - Amplify's SPA rewrite
// returns index.html for every path on every attached domain.
const firstLabel = window.location.hostname.split(".")[0].toLowerCase();

export const isParentHost = /^parents?([-.]|$)/.test(firstLabel);

export const PORTAL_BASE = isParentHost ? "" : "/portal";

/** Absolute portal path: portalPath("/login") -> "/portal/login" or "/login". */
export const portalPath = (path: "" | `/${string}`): string =>
  `${PORTAL_BASE}${path}` || "/";
